import React from 'react';

const AddDrone = () => {
    return (
        <div>
            <h2>This is Add Drone.</h2>
        </div>
    );
};

export default AddDrone;